import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar';
import { ConfigApi } from '@backstage/core-plugin-api';
import { csv } from 'd3';

const getCSVUrl = (domain: string, url: string): string => {
  switch (domain) {
    case 'Tranzact':
      return `${url}/api/proxy/raw_github/TRANZACT/Platforms.Architecture.TechRadar/master/octopus/platform-engineering-development.csv`;
    default:
      return `${url}/api/proxy/raw_github/TRANZACT/fabz-gh-testing/main/data.csv`;
  }
};
const getData = async (url: string, id: string | undefined) => {
  let data;
  try {
    // Fetch the CSV data
    data = await csv(getCSVUrl(id!, url));

    // Transform the data into the format expected by the Tech Radar component
    const techRadarData = {
      quadrants: [
        { id: 'Techniques', name: 'Techniques' },
        { id: 'Platforms', name: 'Platforms' },
        { id: 'Tools', name: 'Tools' },
        { id: 'Languages and Frameworks', name: 'Languages and Frameworks' },
      ],
      rings: [
        { id: 'adopt', name: 'Adopt', color: '#93c47d' },
        { id: 'trial', name: 'Trial', color: '#9370c4' },
        { id: 'assess', name: 'Assess', color: '#ecc94b' },
        { id: 'hold', name: 'Hold', color: '#c44d58' },
      ],
      entries: data.map(row => ({
        title: row.name,
        key: row.name,
        id: row.name,
        quadrant: row.quadrant,
        ring: row.ring,
        description: row.description,
        url: row.url ? row.url : undefined,
        timeline: [
          {
            date: row.date ? new Date(row.date) : new Date(),
            ringId: row.ring,
            moved: row.moved ? parseInt(row.moved, 10) : NaN,
          },
        ],
      })),
    };
    return techRadarData;
  } catch (error) {
    console.log(error); // eslint-disable-line
    return { quadrants: [], rings: [], entries: [] };
  }
};

export class TechRadarClient implements TechRadarApi {
  private readonly config: ConfigApi;

  constructor(config: ConfigApi) {
    this.config = config;

    if (!config) {
      throw new Error('Config is required');
    }
  }

  async load(id: string | undefined): Promise<TechRadarLoaderResponse> {
    // if needed id prop can be used to fetch the correct data
    return getData(this.config.getString('backend.baseUrl'), id);
  }
}
